var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-container"},_vm._l((_vm.count),function(n){return _c('div',{key:n,staticClass:"skeleton-item"},[_c('div',{staticClass:"skeleton skeleton-checkbox"}),_c('div',{staticClass:"skeleton skeleton-label"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }